/**
 * Billing API Service
 * Handles all billing/subscription-related API calls
 */

import { post, get } from './client';

export const billingApi = {
  /**
   * Get subscription status
   */
  getStatus: async () => {
    return get('/api/billing/status');
  },

  /**
   * Start free trial
   */
  startTrial: async (plan) => {
    return post('/api/billing/start-trial', {
      plan,
    });
  },

  /**
   * Create checkout session
   */
  createCheckoutSession: async (priceId, promoCode = null) => {
    return post('/api/billing/checkout', {
      price_id: priceId,
      promo_code: promoCode,
    });
  },

  /**
   * Create portal session
   */
  createPortalSession: async () => {
    return post('/api/billing/portal', {});
  },

  /**
   * Cancel subscription
   */
  cancelSubscription: async () => {
    return post('/api/billing/cancel-subscription', {});
  },

  /**
   * Validate promo code
   */
  validatePromoCode: async (code) => {
    return post('/api/billing/validate-promo', {
      code,
    });
  },

  /**
   * Redeem promo code
   */
  redeemPromoCode: async (code) => {
    return post('/api/billing/redeem-promo-code', {
      code,
    });
  },
};
